<template>
    <div class="lms__superadmin_masteradmin_edit_form">
        <template v-if="user.isSuperadmin()">
            <form-select
                :name="'lms-superadmin-masteradmin-edit-form-customer'"
                :label="'Customer'"
                :is-type="'select'"
                :required="true"
                :value="masteradminCustomerId"
                :v-validate="'required'"
                :data-vv-as="'customer'"
                :get-pagination-getter="'getLmsSuperadminCustomersPagination'"
                :get-items-getter="'getLmsSuperadminCustomersMappedIdNameStatus'"
                :get-items-getter-mapped="'getLmsSuperadminCustomersMappedLabelValue'"
                :get-items-dispatch="'lmsSuperadminCustomersGet'"
                :item-name="['customer', 'customers']"
                :search-queryable="true"
                :table-labels="[
                {
                    key: 'name',
                    title: 'Name',
                    type: 'string',
                    sortable: true,
                    queryable: true
                }
            ]"
                :prevent-clear="true"
                @input="setMasteradminCustomerId"
                @input-table="setMasteradminCustomerId"
            />
        </template>
        <template v-else>
            <template v-if="getCustomerRequestPending">
                <component-loading :size="'small'"></component-loading>
            </template>
            <template v-else>
                <form-text
                    :name="'lms-superadmin-masteradmin-edit-form-customer-readonly'"
                    :label="'Customer'"
                    :value="masteradminCustomerName"
                    :read-only="true"
                ></form-text>
            </template>
        </template>
        <form-text
            :required="true"
            :v-validate="{ required: true, email: true }"
            :label="'Email address'"
            :name="'lms-superadmin-masteradmin-edit-form-email'"
            :data-vv-as="'email'"
            v-model="masteradminEmail"
        ></form-text>
        <form-text
            :required="true"
            :v-validate="{ required: true }"
            :label="'First name'"
            :name="'lms-superadmin-masteradmin-edit-form-first-name'"
            :data-vv-as="'first name'"
            v-model="masteradminFirstName"
        ></form-text>
        <form-text
            :required="true"
            :v-validate="{ required: true }"
            :label="'Last name'"
            :name="'lms-superadmin-masteradmin-edit-form-last-name'"
            :data-vv-as="'last name'"
            v-model="masteradminLastName"
        ></form-text>
    </div>
</template>

<script>
import { validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit } from '@/helpers/mixins'
import FormText from '@/components/default/forms/FormText'
import FormSelect from '@/components/default/forms/FormSelect'
import { User } from '@/User'
import ComponentLoading from '@/components/default/shared/ComponentLoading'

export default {
  name: 'lms-superadmin-admin-edit-form',
  components: { ComponentLoading, FormSelect, FormText },
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit],
  data () {
    return {
      user: new User(),
      getCustomerRequestPending: false
    }
  },
  computed: {
    masteradminCustomerId () {
      return this.$store.getters.getLmsSuperadminMasteradminCustomerId
    },
    masteradminCustomerName () {
      return this.$store.getters.getLmsSuperadminMasteradminCustomerName
    },
    masteradminFirstName: {
      get () {
        return this.$store.getters.getLmsSuperadminMasteradminFirstName
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminMasteradminSetFirstName', value)
      }
    },
    masteradminLastName: {
      get () {
        return this.$store.getters.getLmsSuperadminMasteradminLastName
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminMasteradminSetLastName', value)
      }
    },
    masteradminEmail: {
      get () {
        return this.$store.getters.getLmsSuperadminMasteradminEmail
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminMasteradminSetEmail', value)
      }
    }
  },
  methods: {
    setMasteradminCustomerId (value) {
      this.$store.dispatch('lmsSuperadminMasteradminSetCustomerId', value.constructor === Object ? value.value : value)
    },
    setMasteradminCustomerName (value) {
      this.$store.dispatch('lmsSuperadminMasteradminSetCustomerName', value.constructor === Object ? value.value : value)
    }
  },
  mounted () {
    if (this.user.isMasterAdministrator() && !this.user.isSuperadmin()) {
      this.getCustomerRequestPending = true
      this.$store.dispatch('lmsSuperadminCustomerGet', this.user.getCustomerId()).then(response => {
        const customerId = response.id
        const customerName = response.name

        this.setMasteradminCustomerId(customerId)
        this.setMasteradminCustomerName(customerName)
      }).finally(() => {
        this.getCustomerRequestPending = false
      })
    }
  },
  inject: ['$validator']
}
</script>
